export default __webpack_public_path__ + "static/media/employee-CardBack.2a21e804.png";